import React, { Component } from "react";
import { Button, Modal, Breadcrumb } from "react-bootstrap";
import MUIDataTable from "mui-datatables";
// import FloatingButton from "../../Material/FloatingButton";
import { connect } from "react-redux";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Spinner from "react-bootstrap/Spinner";
import * as FileSaver from "file-saver";
import XLSX from "xlsx";
import ReactTooltip from "react-tooltip";
import * as moment from "moment";
import Moment from "react-moment";
import { withRouter } from "react-router";
import { MdOutlineAdd } from "react-icons/md";
import { Link } from "react-router-dom";

toast.configure();
class delegationList extends Component {
  constructor(props) {
    super(props);

    this.state = {
      MyApplicationList: [],
      deletePopup: false,
      deleteReferenceno: "",
      loading: "",
      downloadExcel: [],
      downloadExcelArray: [],
      isdownloadExcelFirstLoadDone: 0,
    };
  }

  componentDidMount() {
    this.props.dispatch({
      type: "headerTitle",
      value: "Delegation List",
    });
    this.GetListData();
  }

  GetListData = () => {
    try {
      fetch(
        process.env.REACT_APP_WEB_SERVICE_URL + "/api/Admin/DelegationList",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + this.props.getToken,
          },
        }
      )
        .then((response) => {
          if (response.status === 200) {
            return response.json();
          } else if (response.status === 401) {
            this.props.dispatch({ type: "Referenceno", value: "" });
            this.props.dispatch({ type: "UserId", value: "" });
            this.props.dispatch({ type: "profile", value: "" });
            this.props.dispatch({ type: "headerTitle", value: "" });
            this.props.dispatch({ type: "Token", value: "" });
            this.props.dispatch({ type: "userType", value: "" });
            this.props.dispatch({ type: "userName", value: "" });
          }
        })
        .then((data) => {
          if (data) {
            this.setState({
              MyApplicationList: data?.resultObject,
              loading: "Yes",
            });
          }
        })
        .catch((error) => {
          this.props.dispatch({ type: "Referenceno", value: "" });
          this.props.dispatch({ type: "UserId", value: "" });
          this.props.dispatch({ type: "profile", value: "" });
          this.props.dispatch({ type: "headerTitle", value: "" });
          this.props.dispatch({ type: "Token", value: "" });
          this.props.dispatch({ type: "userType", value: "" });
          this.props.dispatch({ type: "userName", value: "" });
        });
    } catch (e) {
      console.log(e);
    }
  };

  viewRequest = (value, tableMeta, updateValue) => {
    var CryptoJS = require("crypto-js");
    window.location =
      process.env.REACT_APP_ENV +
      "/edoctype/view?p=" +
      encodeURI(
        CryptoJS.AES.encrypt(
          JSON.stringify(tableMeta.rowData?.[0]),
          process.env.REACT_APP_ENCRYPT_PASSWORD
        ).toString()
      );
  };

  editRequest = (value, tableMeta, updateValue) => {
    var CryptoJS = require("crypto-js");
    window.location =
      process.env.REACT_APP_ENV +
      "/edoctype/edit?p=" +
      encodeURI(
        CryptoJS.AES.encrypt(
          JSON.stringify(tableMeta.rowData?.[0]),
          process.env.REACT_APP_ENCRYPT_PASSWORD
        ).toString()
      );
  };

  deleteRequest = (value, tableMeta, updateValue) => {
    this.setState({
      deletePopup: true,
      deleteReferenceno: tableMeta?.rowData[0],
    });
  };

  cancelDelete = () => {
    this.setState({ deletePopup: false, deleteReferenceno: "" });
  };

  downloadExcelFile = () => {
    const Heading = [
      {
        header1: "Reference No",
        header2: "eDoc Type",
        header3: "Requester name",
        header4: "Submitted Date",
        header5: "Original Approver",
        header6: "Delegate Approver",
      },
    ];
    (async () => {
      await this.setState({ downloadExcelArray: [] });
    })();
    if (this.state.downloadExcel.length > 0) {
      (async () => {
        await this.state.downloadExcel.forEach((value, index) => {
          let mdData = [
            value.data[0],
            value.data[1],
            value.data[2],
            value.data[3],
            value.data[4],
            value.data[5],
            "Deligation List",
          ];
          this.state.downloadExcelArray.push(mdData);
          return null;
        });
      })();
    } else {
      (async () => {
        await this.state.MyApplicationList?.forEach((value, index) => {
          let mdData = [
            value.referenceno,
            value.eDocType,
            value.requesterName,
            value.createdDate
              ? moment(value.createdDate).format("DD-MM-yyyy HH:mm:ss")
              : "",
            value.originalapprovername,
            value.delegatetoname,
          ];
          this.state.downloadExcelArray.push(mdData);
          return null;
        });
      })();
    }

    const fileType =
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
    const filename = "delegateList.xlsx";

    const ws = XLSX.utils.json_to_sheet(Heading, {
      skipHeader: true,
      origin: 0,
    });
    XLSX.utils.sheet_add_json(ws, this.state.downloadExcelArray, {
      skipHeader: true,
      origin: -1,
    });
    const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const data = new Blob([excelBuffer], { type: fileType });
    FileSaver.saveAs(data, filename);
  };

  printRequest = () => {
    window.location = process.env.REACT_APP_ENV + "/delegation/list";
  };

  render() {
    let dataArray = [];
    this.state.MyApplicationList?.map((value) => {
      let mdData = [
        value.referenceno,
        value.eDocType,
        value.requesterName,
        value.createdDate
          ? moment(value.createdDate).format("DD-MM-yyyy HH:mm:ss")
          : "",
        value.originalapprovername,
        value.delegatetoname,
      ];
      dataArray.push(mdData);
      return null;
    });

    const columns = [
      {
        name: "Reference No",
        label: "Reference No",
        options: {
          filter: false,
          sort: true,
          viewColumns: false,
        },
      },
      {
        name: "edoctypes",
        label: "eDoc Types",
        options: {
          filter: true,
          sort: true,
          viewColumns: false,
        },
      },
      {
        name: "Requester Name",
        label: "Requester Name",
        options: {
          filter: true,
          sort: true,
          viewColumns: false,
        },
      },
      {
        name: "Submitted Date",
        label: "Submitted Date",
        options: {
          filter: false,
          sort: true,
          viewColumns: false,
        },
      },
      {
        name: "Original Approver",
        label: "Original Approver",
        options: {
          filter: true,
          sort: true,
          viewColumns: false,
        },
      },

      {
        name: "Delegate Approver",
        label: "Delegate Approver",
        options: {
          filter: true,
          sort: true,
          viewColumns: false,
        },
      },
    ];

    const options = {
      filterType: "checkbox",
      download: false,

      viewColumns: false,
      print: true,
      textLabels: {
        body: {
          noMatch: this.state.loading ? (
            "Sorry, there is no matching data to display"
          ) : (
            <Spinner
              animation="border"
              variant="primary"
              style={{ margin: "auto" }}
            />
          ),
        },
      },
      onTableChange: (action, tableState) => {
        if (this.state.isdownloadExcelFirstLoadDone === 0) {
          if (action === "propsUpdate") {
            this.setState({
              downloadExcel: tableState.displayData,
              isdownloadExcelFirstLoadDone: 1,
            });
          }
        }
        if (action === "search" || action === "sort") {
          (async () => {
            await this.setState({ downloadExcel: [] });
          })();
          this.setState({ downloadExcel: tableState.displayData });
        }
      },
      customToolbar: () => {
        return (
          <>
            <button
              className="MuiButtonBase-root MuiIconButton-root MUIDataTableToolbar-icon-23"
              tabindex="0"
              type="button"
              data-testid="Download CSV-iconButton"
              aria-label="Download CSV"
              onClick={this.downloadExcelFile}
            >
              <span className="MuiIconButton-label">
                <svg
                  className="MuiSvgIcon-root"
                  focusable="false"
                  viewBox="0 0 24 24"
                  aria-hidden="true"
                >
                  <path d="M19.35 10.04C18.67 6.59 15.64 4 12 4 9.11 4 6.6 5.64 5.35 8.04 2.34 8.36 0 10.91 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96zM17 13l-5 5-5-5h3V9h4v4h3z"></path>
                </svg>
              </span>
              <span className="MuiTouchRipple-root"></span>
            </button>
            <Link to="/delegation">
              <Button size="sm" color="primary">
                Delegate
              </Button>
            </Link>
          </>
        );
      },
    };

    return (
      <>
        <Breadcrumb>
          <Breadcrumb.Item href={process.env.REACT_APP_ENV + "/dashboard"}>
            Dashboard
          </Breadcrumb.Item>
          <Breadcrumb.Item active>Delegation List</Breadcrumb.Item>
        </Breadcrumb>
        <div className="col-xs-2">
          {" "}
          <MUIDataTable
            title={"Delegation List"}
            data={dataArray}
            columns={columns}
            options={options}
          />{" "}
        </div>
        <p className="text-center"></p>
        <Modal show={this.state.deletePopup}>
          <Modal.Header>Delete Confirmation</Modal.Header>
          <Modal.Body>
            <div className="alert alert-danger" role="alert">
              Are you sure you want to delete?
            </div>
            <hr></hr>
            <div className="text-right">
              <Button className="btn btn-light" onClick={this.cancelDelete}>
                {" "}
                No{" "}
              </Button>
              <Button
                className="btn btn-primary-01 ml-3"
                onClick={this.confirmDelete}
              >
                {" "}
                Yes{" "}
              </Button>
            </div>
          </Modal.Body>
        </Modal>
        {/* <FloatingButton /> */}
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    menuVisibility: state.menuVisibility,
    menuStatusHeader: state.menuStatusHeader,
    headerTitle: state.headerTitle,
    getToken: state.token,
    userType: state.userType,
    userName: state.userName,
    UserId: state.UserId,
  };
};

export default connect(mapStateToProps)(delegationList);
